import React from 'react';
import { TextFieldWithLabel, Link } from '../library-components';

import '../ssoLogin/user_form.scss';

function UserForm (props) {
  const { pageType, data, onFormValueChange } = props;
  return <div className="form-fields">
    {
      pageType === 'create_user' && pageType !== 'forgot-password' &&
      <TextFieldWithLabel
        label="Name"
        value={data.name}
        error={data.nameError}
        onChange={e => onFormValueChange('name', e.target.value)}
        type="name"
      />
    }
    {
      pageType !== 'reset-password' &&
      <TextFieldWithLabel
        label="Email"
        value={data.email}
        error={data.emailError}
        onChange={e => onFormValueChange('email', e.target.value)}
        type="email"
      />
    }
    {
      pageType !== 'forgot-password' &&
        <TextFieldWithLabel
          label="Password"
          inputType="password"
          value={data.password}
          error={data.passwordError}
          onChange={e => onFormValueChange('password', e.target.value)}
        />
    }
    {
      pageType === 'reset-password' &&
        <TextFieldWithLabel
          label="Confirm Password"
          inputType="password"
          value={data.confirmPassword}
          error={data.passwordError}
          onChange={e => onFormValueChange('confirmPassword', e.target.value)}
        />
    }
    {
      pageType === 'login' &&
      <p className="forgot--cta">
        <Link external={false} url="/forgot-password">Forgot Password?</Link>
      </p>
    }
    {pageType === 'create_user' && (
      <div className="dpa-form">
        <input
          type="checkbox"
          checked={!!data.termsAccepted}
          onChange={(e) =>
            onFormValueChange('termsAccepted', e.target.checked)
          }
          className='dpa-checkbox'
        />
        <span className='dpa-terms-policy-span'>
          I agree to the{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.quintype.com/accesstype-and-metype-terms"
          >
            Terms & Conditions
          </a>
          {' '}and{' '}
          <a href="https://www.quintype.com/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </span>
        {data.termsError && (
          <div className='dpa-error-message'>
            *Please accept the Terms and Privacy Policy to continue.
          </div>
        )}
      </div>
    )}
  </div>;
}

export default UserForm;
